import React, { useContext } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faShoppingBasket } from '@fortawesome/free-solid-svg-icons'
import { useCart } from '../../contexts/CartContext'
import { Link } from 'react-router-dom'
import { CART_PATH } from '../../config/routes'

const CartIcon = () => {
  const isShopEnabled = process.env.REACT_APP_TOGGLE_SHOP === 'true'
  const { cartItems } = useCart()

  if (!isShopEnabled) {
    return null
  }

  const totalItemsInCart = cartItems.reduce(
    (total, item) => total + item.quantity,
    0,
  )

  return (
    <div
      className="cart-icon-container"
      style={{ position: 'relative', marginRight: '5px' }}
    >
      <Link to={CART_PATH} style={{ color: 'inherit' }}>
        <FontAwesomeIcon
          icon={faShoppingBasket}
          style={{ marginRight: '20px', cursor: 'pointer', width: '4Opx' }}
        />
      </Link>

      {totalItemsInCart > 0 && (
        <div
          className="cart-bubble"
          style={{
            position: 'absolute',
            top: '-5px',
            right: '3px',
            backgroundColor: 'red',
            color: 'white',
            borderRadius: '50%',
            padding: '1px 6px',
            fontSize: '12px',
          }}
        >
          {totalItemsInCart}
        </div>
      )}
    </div>
  )
}

export default CartIcon
